import script from "./FooterSocials.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterSocials.vue?vue&type=script&setup=true&lang=ts"

import "./FooterSocials.vue?vue&type=style&index=0&id=153ae893&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153ae893"]])

export default __exports__